'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { ROUTES } from '@/constants';
export const AccumulatedSection = () => {
  const $ = _c(28);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/home-donation-event-history/summary"]({}),
      select: _temp,
      staleTime: 0,
      gcTime: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data
  } = useSuspenseQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col gap-24 rounded-medium border border-Gray-300 px-20 pb-20 pt-24 transition-colors duration-300 hover:bg-Gray-50/50", "mobile-tablet:mx-20");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-500 text-Gray-800 typo-body4">총 적립금</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <img alt="point" className="size-16" src="/assets/pngs/coin2.png" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== data?.totalRewardAmount) {
    t4 = data?.totalRewardAmount?.toLocaleString();
    $[4] = data?.totalRewardAmount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <p className="font-700 text-Gray-black typo-body1">{t4}원</p>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgChevronright className="size-16 text-Gray-600" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <div className="flex items-center justify-between">{t2}<div className="flex items-center gap-2">{t3}{t5}{t6}</div></div>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="font-500 text-Gray-800 typo-body4">가입한 친구</p>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== data?.joinedFriendCount) {
    t9 = data?.joinedFriendCount?.toLocaleString();
    $[12] = data?.joinedFriendCount;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t9) {
    t10 = <div className="flex flex-1 items-center justify-center gap-8">{t8}<p className="font-700 text-B-500 typo-body4">{t9}명</p></div>;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="h-24 w-1 bg-Gray-300" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="font-500 text-Gray-800 typo-body4">친구 기부 횟수</p>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== data?.friendDonationCount) {
    t13 = data?.friendDonationCount?.toLocaleString();
    $[18] = data?.friendDonationCount;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13) {
    t14 = <div className="flex flex-1 items-center justify-center gap-8">{t12}<p className="font-700 text-B-500 typo-body4">{t13}명</p></div>;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t10 || $[23] !== t14) {
    t15 = <div className="flex items-center justify-between py-3">{t10}{t11}{t14}</div>;
    $[22] = t10;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15 || $[26] !== t7) {
    t16 = <CustomLink aria-label={"\uC6F0\uD3EC\uC778\uD2B8\uC0C1\uC810"} href={ROUTES.POINT_MARKET.pathname} className={t1}>{t7}{t15}</CustomLink>;
    $[25] = t15;
    $[26] = t7;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}